export default {
  showChallengeModal: false,
  showChallengeExpirationModal: false,
  showSummaryModal: false,
  showChallengeLeiCodeModal: false,
  showChallengeRelationshipModal: false,
  showChallengeRelationshipDetailsModal: false,
  showChallengeAddressModal: false,
  showChallengePeriodsModal: false,
  parentType: null,
  challengeRelationshipDetails: null,
  currentRelationshipTypes: {
    directParent: '',
    ultimateParent: '',
    fundManager: '',
    umbrellaFund: '',
    masterFund: '',
    headOffice: '',
  },
  fields: [],
  challenge: {
    filter: null,
    type: null,
    title: null,
    oldValue: null,
    jsonPath: null,
    text: null,
  },
  summary: {},
  challengeAddress: {
    country: null,
    addressLines: [],
    addressNumber: null,
    addressNumberWithinBuilding: null,
    mailRouting: null,
    postalCode: null,
    city: null,
    region: null,
    rootPath: null,
    title: null,
  },
  challengePeriods: {
    type: {},
    startDate: {},
    endDate: {},
    title: null,
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/record/modules/challenge/state.js